export default __webpack_public_path__ + "static/media/playlist.e2303400.svg";